import {useState, useEffect, useContext} from 'react'
import { UserStoreContext } from '../Contexts/UserStoreContext';
import Axios from 'axios';
import ENVIROMENTS from '../Environment/Configuration.json';

const useFetch = (request) => {
    const [data, setData] = useState(null);
    const[isLoading, setIsLoading] = useState(true);
    const[error, setError] = useState(null);
    
    const {is_logged_in, user_store} = useContext(UserStoreContext)
    
    useEffect(()=>{ 

        setIsLoading(true)
        setError(null)
        setData(null)
        if(request){
                const url = ENVIROMENTS.baseUrl + '/geniuxmusic/api/fetch_comments_replies.php';
                let cancel
                Axios({
                    method: 'post',
                    url: url,
                    data: {
                        song_id: request.song_id,
                        commented_id: request.commented_id,
                        page: request.page,
                        myuserid: is_logged_in?user_store.user_id:"",
                        mytoken: is_logged_in?user_store.user_token:"",
                    },
                    cancelToken: new Axios.CancelToken(c => cancel = c),

                })
                
                .then(response=>{
                    setIsLoading(false)
                    if(response.data && response.data.status==="success"){
                        setData(response.data)
                    }else{
                        setError("network_err")
                    }
                
                })
                .catch(err=>{
                    if(!Axios.isCancel(err)){
                        setError('network_err');
                        setIsLoading(false)
                    }
                })
                return () => cancel()
           
        }else{
            setIsLoading(false)
        }
    
    
    },[request])
 
    return {data, isLoading, error}
}

export default useFetch
